import React, { useEffect, useState, useRef } from "react";
import Masonry from "react-masonry-css";
import PostCard from "../postcard/Postcard";
import Menu from "../menu/Menu";
import "./Profile.css";

const breakpointColumnsObj = {
  default: 4,
  1100: 3,
  700: 2,
  500: 1,
};

export default function Profile() {
  useEffect(() => {
    document.title = "splash overflow | Profil";
  }, []);

  const [user, setUser] = useState(null);
  const [userPosts, setUserPosts] = useState([]);

  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    profession: "",
    profile_img: null,
  });

  const [previewImg, setPreviewImg] = useState(null);

  const fileInputRef = useRef(null);

  const [originalData, setOriginalData] = useState(null);

  useEffect(() => {
    if (!user) return;

    const initialData = {
      username: user.username || "",
      email: user.email || "",
      profession: user.profession || "",
      profile_img: null,
    };

    setFormData(initialData);
    setOriginalData(initialData);

    if (user.profile_img) {
      setPreviewImg(`${API_URL}/uploads/profileImg/${user.profile_img}`);
    } else {
      setPreviewImg(null);
    }
  }, [user]);

  const isChanged = () => {
    if (!originalData) return false;
    return (
      formData.username !== originalData.username ||
      formData.email !== originalData.email ||
      formData.profession !== originalData.profession ||
      formData.profile_img !== null
    );
  };

  const handleCancel = () => {
    if (!originalData) return;

    setFormData(originalData);
    if (user.profile_img) {
      setPreviewImg(`${API_URL}/uploads/profileImg/${user.profile_img}`);
    } else {
      setPreviewImg(null);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    fetch(`${API_URL}/api/me`, { credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data) {
          setUser(data);
          fetch(`${API_URL}/api/posts`)
            .then((res) => (res.ok ? res.json() : []))
            .then((posts) => {
              const filtered = posts.filter(
                (post) => post.user_id === data.userId
              );
              setUserPosts(filtered);
            });
        }
      });
  }, []);

  useEffect(() => {
    if (!user) return;

    setFormData({
      username: user.username || "",
      email: user.email || "",
      profession: user.profession || "",
      profile_img: null,
    });

    if (user.profile_img) {
      setPreviewImg(`${API_URL}/uploads/profileImg/${user.profile_img}`);
    } else {
      setPreviewImg(null);
    }
  }, [user]);

  const handleDeletePost = async (postId) => {
    if (!window.confirm("Willst du diesen Post wirklich löschen?")) return;

    try {
      const response = await fetch(`${API_URL}/api/posts/${postId}`, {
        method: "DELETE",
        credentials: "include",
      });

      if (response.ok) {
        setUserPosts((prev) => prev.filter((post) => post.id !== postId));
      } else {
        alert("Fehler beim Löschen des Posts.");
      }
    } catch (err) {
      console.error("Löschen fehlgeschlagen:", err);
      alert("Beim Löschen ist ein Fehler aufgetreten.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, profile_img: file }));
      setPreviewImg(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("username", formData.username);
    data.append("email", formData.email);
    data.append("profession", formData.profession);
    if (formData.profile_img) {
      data.append("profile_img", formData.profile_img);
    }

    try {
      const res = await fetch(`${API_URL}/api/profile/update`, {
        method: "POST",
        credentials: "include",
        body: data,
      });

      if (res.ok) {
        alert("Profil aktualisiert");
        const updatedUser = await res.json();
        setUser(updatedUser);
      } else {
        alert("Fehler beim Aktualisieren");
      }
    } catch (err) {
      console.error(err);
      alert("Serverfehler");
    }
  };

  return (
    <div>
      <Menu user={user} setUser={setUser} />
      <div className="ProfilePadding">
        <span
          className="profile-title"
          style={{ fontWeight: "600", fontSize: "2em" }}
        >
          Mein Profil
        </span>

        <form
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          className="profile-form"
        >
          <div
            className="flex items-center profileInput"
            style={{ marginTop: "1em" }}
          >
            <img
              src={previewImg || "/default-profile.png"}
              alt="Profilbild"
              style={{
                width: 100,
                height: 100,
                objectFit: "cover",
                cursor: "pointer",
                borderRadius: "50%",
                border: "2px solid #ccc",
                margin: "0 1em 0 1em",
              }}
              onClick={handleImageClick}
              title="Profilbild ändern"
            />
            <div>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </div>
            <div className="flex flex-row">
              <div className="textBorderProfile flex flex-column">
                <span className="profileEditTitle">Username</span>
                <input
                  type="text"
                  className="transparentInputProfile inter"
                  title="Username"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="textBorderProfile flex flex-column">
                <span className="profileEditTitle">Email</span>
                <input
                  type="email"
                  className="transparentInputProfile inter"
                  title="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="textBorderProfile flex flex-column">
                <span className="profileEditTitle">Rolle</span>
                <input
                  type="text"
                  className="transparentInputProfile inter"
                  title="Rolle"
                  name="profession"
                  value={formData.profession}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          {isChanged() && (
            <div
              style={{
                marginTop: "1em",
                marginLeft: "1em",
                display: "flex",
                gap: "1rem",
              }}
            >
              <button className="buttonProfile inter" type="submit">
                Profil aktualisieren
              </button>
              <button
                className="buttonProfile inter"
                type="button"
                onClick={handleCancel}
              >
                Abbrechen
              </button>
            </div>
          )}
        </form>

        <span
          className="profile-title"
          style={{ fontWeight: "600", fontSize: "2em", marginTop: "2rem" }}
        >
          Meine Posts
        </span>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
        >
          {userPosts.map((post) => (
            <div key={post.id} className="post-wrapper">
              <PostCard post={post} />
              <div className="info flex items-center justify-between px-4 py-2">
                <div className="text-sm text-gray-500">
                  {new Date(post.created_at).toLocaleDateString("de-DE", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </div>
                <div
                  className="delete-button flex items-center cursor-pointer"
                  onClick={() => handleDeletePost(post.id)}
                >
                  <span
                    className="icon material-icons text-red-600"
                    title="Post löschen"
                  >
                    delete_forever
                  </span>
                </div>
              </div>
            </div>
          ))}
        </Masonry>
      </div>
    </div>
  );
}
